import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'img[default]',
  host: {
    '(error)':'updateUrl()',
    '[src]':'src'
  },
  standalone: true
})
export class DefaultImageDirective {

  @Input() src: string | undefined;
  @Input() default: string | undefined;

  updateUrl() {
    this.src = this.default;
  }
}
